import { render } from "./all-log-action.vue?vue&type=template&id=5d1b562d&scoped=true"
import script from "./all-log-action.vue?vue&type=script&lang=js"
export * from "./all-log-action.vue?vue&type=script&lang=js"

import "./all-log-action.vue?vue&type=style&index=0&id=5d1b562d&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1b562d"]])

export default __exports__